import { Modal } from '../Modal';
import { ErrorModalProps, SuccessModalContentProps } from './types';


function SuccessModalContent({ title, content, onClose }: SuccessModalContentProps) {
    return (
        <div className="form-message _success">
            <div className="form-message__icon"></div>
            <h2 className="popup__heading form-message__heading" style={{ textAlign: 'center' }}>
                {title}
            </h2>
            <div className="form-message__copy" style={{ textAlign: 'center' }}>
                {content}
            </div>
            <div className="form-message__ok">
                <span className="btn" onClick={() => onClose()}>
                    OK
                </span>
            </div>
        </div>
    );
}

export function SuccessModal({ title, content, isOpen, onClose }: ErrorModalProps) {
    return (
        <Modal className={'popup_message'} isOpen={isOpen} onClose={() => onClose()}>
            <SuccessModalContent title={title} content={content} onClose={onClose} />
        </Modal>
    );
}
